import { styled } from '@mui/material';

export const SubTitle = styled('p')(({ theme }) => ({
	margin: 0,
	color: theme.palette.mode === 'dark' ? theme.palette.text.secondary : '#999999',
	fontSize: '12px',
	fontWeight: '500',
	lineHeight: '20px',
}));
